import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_ONPREMISE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

interface OnboardingStepsSettings {
    tariff: string;
    showTimeMS: number;
    paySourceId: string; // пробрасывается в окно оплаты
    openingDelayMS: number;
}

/** Онбординг степы для новых пользователей https://jira.vk.team/browse/CLOUDWEB-18836 */
export const onboardingStepsFeature: 'a' | 'b' = !IS_MOBILE_BROWSER && !IS_WEBVIEW && !IS_ONPREMISE && getFeature('onboarding-steps');
export const onboardingStepsEnabled: boolean = onboardingStepsFeature === 'b';
export const onboardingStepsSettings: OnboardingStepsSettings = getFeature('onboarding-steps-settings');
export const onboardingOpeningDelayMS = onboardingStepsSettings.openingDelayMS;
